import React, { useState, useEffect, useRef, useCallback } from 'react';
import MainLayoutWithoutFooter from '../components/MainLayoutWithoutFooter';
import OrderDetailsModal from '../components/modals/OrderDetailsModal';
import AcceptOrderModal from '../components/modals/AcceptOrderModal';
import StoreSelectionModal from '../components/modals/StoreSelectionModal';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { HTTP_STATUS } from '../utils/httpStatusCodes';
import { toast } from 'react-toastify';

const UberEatsOrders = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [day, setDay] = useState('today');
  const [uberToken, setUberToken] = useState(false);

  const [stores, setStores] = useState([]);
  const [existingStores, setExistingStores] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState('');
  const [selectedStores, setSelectedStores] = useState([]);

  const [modalOrderId, setModalOrderId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [acceptAction, setAcceptAction] = useState(null);
  const [acceptModalOpen, setAcceptModalOpen] = useState(false);

  const [storeModalOpen, setStoreModalOpen] = useState(false);

  const clientIdRef = useRef(null);
  const sseRef = useRef(null);
  const reconnectTimeout = useRef(1000);
  const reconnectTimer = useRef(null);

  const OrderStatus = {
    INACTIVE: 0,
    ACTIVE: 1,
    PENDING: 2,
    PLACED: 3,
    COOKING: 4,
    READY: 5,
    OUT_FOR_DELIVERY: 6,
    COMPLETED: 7,
    REJECTED: 8,
    CANCELLED: -1
  };

  

  
  useEffect(() => {
    const fetchExistingStores = async () => {
      try {
        const res = await callAPI(apiUrls.UBEREATS_EXISTING_LIST_STORES, {}, 'GET');
        if (res.status === HTTP_STATUS.OK && Array.isArray(res.data.stores)) {
          setExistingStores(res.data.stores);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchExistingStores();
  }, []);


  
  const fetchListing = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      let url = apiUrls.UBEREATS_LISTING + `?day=${params.day ?? day}`;
      if (params.store_id) url += `&store_id=${params.store_id}`;
      const resp = await callAPI(url, {}, 'GET');

      if (resp && resp.data) {
        setRecords(resp.data.data || []);
        setUberToken(resp.data.token);
        clientIdRef.current = resp.data.store;
   
        if (
          resp.data.token &&
          (!resp.data.store_connected || Object.keys(resp.data.store_connected).length === 0)
        ) {
          const sresp = await callAPI(apiUrls.UBEREATS_STORES_LISTING, {}, 'GET');
          if (sresp.data && Array.isArray(sresp.data.stores)) {
            setStores(sresp.data.stores);
            setStoreModalOpen(true);
          }
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [day]);

  useEffect(() => {
    fetchListing({ day, store_id: selectedRestaurant });
  }, [day, selectedRestaurant]);

  useEffect(() => {
    if (!clientIdRef.current) return;
    connectSSE();
  }, [clientIdRef.current]);

  useEffect(() => {
    return () => {
      if (sseRef.current) {
        sseRef.current.close();
      }
  
      if (reconnectTimer.current) {
        clearTimeout(reconnectTimer.current);
      }
    };
  }, []);

  const isConnecting = useRef(false);

  const connectSSE = useCallback(() => {
    if (sseRef.current) {
      sseRef.current.close();
      sseRef.current = null;
    }
  
    if (!clientIdRef.current) return;
    if (isConnecting.current) return;

    isConnecting.current = true;
  
    

    const url = `https://events.orderart.io/notification/events?clientId=${clientIdRef.current}`;
    const evt = new EventSource(url);
  
    sseRef.current = evt;
  
    evt.onopen = () => {
      reconnectTimeout.current = 1000;
      isConnecting.current = false;
      if (reconnectTimer.current) {
        clearTimeout(reconnectTimer.current);
        reconnectTimer.current = null;
      }
      console.log("SSE connected");
    };
  
    evt.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
  
        const newOrder = {
          ...data.notification,
          orderstatus: Number(data.notification.orderstatus),
          highlight: true
        };
  
        setRecords(prev => {
          const exists = prev.find(o => o.id == newOrder.id);
          if (exists) return prev;
  
          const updated = [newOrder, ...prev];
  
          setTimeout(() => {
            setRecords(curr =>
              curr.map(o =>
                o.id == newOrder.id ? { ...o, highlight: false } : o
              )
            );
          }, 3000);
  
          return updated;
        });
  
      } catch (err) {
        console.error(err);
      }
    };
  
    evt.onerror = () => {
      isConnecting.current = false;
      evt.close();
      sseRef.current = null;
    
      if (reconnectTimer.current) {
        clearTimeout(reconnectTimer.current);
      }
    
      reconnectTimer.current = setTimeout(() => {
        connectSSE();
      }, reconnectTimeout.current);
    };

  }, []);
  
  const handleConnectUber = () => {
    alert("connect from old pos for now")
  //   window.location.href = apiUrls.ubereatsAuthorize; 
  };

  const handleDisconnectUber = async () => {
    try {
      const resp = await callAPI(apiUrls.UBEREATS_DISCONNECT, {}, 'GET');
      if (resp && resp.status) fetchListing();
    } catch (err) { console.error(err); }
  };

  const openOrderDetails = (orderId) => { setModalOrderId(orderId); setModalOpen(true); };
  const openAcceptModal = (orderId, actionType) => { setAcceptAction({ orderId, actionType }); setAcceptModalOpen(true); };

  const handleAcceptAction = async (orderId, actionType, extraData = {}) => {
    let url = '', body = {};
    switch (actionType) {
      case 'accept': url = apiUrls.UBEREATS_ACCEPT; body = { orderId, pickup_time: extraData.delay_time }; break;
      case 'reject': url = apiUrls.UBEREATS_REJECT; body = { orderId, reason: extraData.reason }; break;
      case 'cancel': url = apiUrls.UBEREATS_CANCEL; body = { orderId, reason: extraData.reason }; break;
      case 'ready': url = apiUrls.UBEREATS_MARK_READY; body = { orderId }; break;
      default: return;
    }
    try {
      const resp = await callAPI(url, {}, 'POST', body);
      setAcceptModalOpen(false);
      if (resp?.status) {
        toast.success(resp.message || 'Success');
        fetchListing();
      } else {
        toast.error(resp?.message || 'Something went wrong');
      }
    } catch (err) { console.error(err); }
  };

  const toggleStoreSelection = (storeId) => {
    setSelectedStores(prev => prev.includes(storeId) ? prev.filter(id => id !== storeId) : [...prev, storeId]);
  };

  const handleStoreModalSave = async () => {
    try {
      const resp = await callAPI(apiUrls.UBEREATS_INTEGRATE_STORE, {}, 'POST', { store_ids: selectedStores });
      if (resp && resp.status) { setStoreModalOpen(false); fetchListing(); }
    } catch (err) { console.error(err); }
  };

  
  const formatShortDate = (date) => {
    if (!date) return "--";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB") + " " + d.toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"});
  };

  // const canShowActions = (order) => {
  //   const created = new Date(order.created_at).toDateString();
  //   const today = new Date().toDateString();
  //   return created === today && order.orderstatus === OrderStatus.PLACED;
  // };
  const canShowActions = (order) => {
    return order.orderstatus == OrderStatus.PLACED;
  };

  const handlePrint = async (orderId, type) => {
    try {
      const url = `${apiUrls.ORDER_PRINT_URL}?order_id=${orderId}&docket=${type}`;
      const resp = await callAPI(url, {}, 'GET');
  
      if (resp?.status) toast.success(resp.message);
      else toast.error(resp.message);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <MainLayoutWithoutFooter>
      <div className="pageContent orderPage pb-3">
        <div className="container">

          
          <div className="customerCol">
  <div className="row gx-2 gy-3 gy-lg-0 align-items-center mb-4">

  
    <div className="col-md-auto">
      <select
        className="form-select form-select-sm"
        value={selectedRestaurant}
        onChange={(e) => setSelectedRestaurant(e.target.value)}
      >
        <option value="">All Restaurants</option>
        {existingStores.map((store) => (
          <option key={store.store_id} value={store.store_id}>
            {store.store_name}
          </option>
        ))}
      </select>
    </div>

    
    <div className="col d-flex justify-content-end align-items-center gap-2">

    
      <div className="btnGroup tableFilterBtns">
        {[
          ["today", "Today"],
          ["yesterday", "Yesterday"],
          ["seven_days", "Last 7 days"],
          ["thirty_days", "Last 30 days"],
        ].map(([value, label], i) => (
          <React.Fragment key={value}>
            <input
              type="radio"
              className="btn-check"
              name="tFilterRadio"
              id={`filter-${i}`}
              autoComplete="off"
              value={value}
              checked={day === value}
              onChange={(e) => setDay(e.target.value)}
            />
            <label className="radioBtn" htmlFor={`filter-${i}`}>
              {label}
            </label>
          </React.Fragment>
        ))}
      </div>

      
      {uberToken ? (
        <button className="btn btn-sm btnPrimary" onClick={handleDisconnectUber}>
          Disconnect
        </button>
      ) : (
        <button className="btn btn-sm btnPrimary" onClick={handleConnectUber}>
          Connect with Uber
        </button>
      )}

    </div>
  </div>
</div>
      
          {uberToken && (
            <div className="cardStyle">
              <div className="table-responsive">
                <table className="table tableStyle2 table-borderless align-middle">
                  <thead>
                    <tr>
                      <th>Uber Order ID</th>
                      <th>Customer</th>
                      <th>Date</th>
                      <th>Due Date</th>
                      <th>Restaurant</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr><td colSpan="6">Loading...</td></tr>
                    ) : records.length ? (
                      records.map(order => (
                        <tr key={order.id} className={order.highlight ? 'table-warning' : ''}>
                          <td>{order.display_id || '--'}</td>
                          <td>{order.first_name || ''} {order.last_name || ''}</td>
                          <td>{formatShortDate(order.placed_at)}</td>
                          <td>{formatShortDate(order.estimated_ready_for_pickup_at)}</td>
                          <td>{order.store_name}</td>
                          <td>
                            <div className="d-flex flex-wrap gap-2">

                              
                              <button
                                className="btn btn-sm btnPrimary"
                                onClick={() => openOrderDetails(order.id)}
                              >
                                Details
                              </button>

                              
                              {order.orderstatus == OrderStatus.PLACED && canShowActions(order)  && (
                                <>
                                  <button
                                    className="btn btn-sm btn-success"
                                    onClick={() => openAcceptModal(order.id, 'accept')}
                                  >
                                    Accept
                                  </button>
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => openAcceptModal(order.id, 'reject')}
                                  >
                                    Reject
                                  </button>
                                </>
                              )}

                              
                              {order.orderstatus == OrderStatus.COOKING && (
                                <>
                                  <button
                                    className="btn btn-sm btn-success"
                                    onClick={() => openAcceptModal(order.id, 'ready')}
                                  >
                                    Mark Ready
                                  </button>
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => openAcceptModal(order.id, 'cancel')}
                                  >
                                    Cancel
                                  </button>
                                </>
                              )}

                              <button
                                className="btn btn-sm btn-dark"
                                onClick={() => handlePrint(order.id, 'kitchen')}
                              >
                                Kitchen
                              </button>

                              <button
                                className="btn btn-sm btn-dark"
                                onClick={() => handlePrint(order.id, 'billing')}
                              >
                                Billing
                              </button>

                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="6" className="text-center">No Order exist!</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

        </div>

      </div>

      <OrderDetailsModal isOpen={modalOpen} orderId={modalOrderId} onClose={()=>setModalOpen(false)} />
      <AcceptOrderModal isOpen={acceptModalOpen} action={acceptAction} onSubmit={(data)=>{if(acceptAction)handleAcceptAction(acceptAction.orderId,acceptAction.actionType,data)}} onClose={()=>setAcceptModalOpen(false)} />
      <StoreSelectionModal isOpen={storeModalOpen} stores={stores} selectedStores={selectedStores} onToggle={toggleStoreSelection} onSave={handleStoreModalSave} onClose={()=>setStoreModalOpen(false)} />

    </MainLayoutWithoutFooter>
  );
};

export default UberEatsOrders;